import reducer from './reducer';

export {
  initVideo,
  setTogglePlayPause,
  setVolume,
  setToggleMuted,
  setProgress,
  setDuration,
  setSeeking,
  setFullScreen,
  setStopped,
  setMilestone,
  resetMilestone,
  setMediaPlay,
} from './actions';

export default reducer;
